module.exports = __webpack_public_path__ + "img/logo.d307e85f.png";